import type { LLHeaderElement } from '../../types';

export function HeaderElement({ element }: { element: LLHeaderElement }) {
  return <h3 className="text-base font-semibold mt-2">{element.text}</h3>;
}
